module.exports = __webpack_public_path__ + "static/img/spike_icon.dbe3d088.png";